var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.show
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "errorPopup" } }, [
          _c("div", { staticClass: "title" }, [
            _vm._v("\r\n            " + _vm._s(_vm.title) + "\r\n        ")
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "error-body" }, [
            _c("span", [_vm._v(_vm._s(_vm.message))])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "task-footer" }, [
            _c(
              "button",
              {
                staticClass: "task-button",
                on: {
                  click: function($event) {
                    return _vm.closePage()
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7bc42321", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bc42321","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/error_popup.vue
// module id = null
// module chunks = 